import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import { useEmailOrganizerMutation, useGetUserInfoQuery } from '../services/api';
import { toast } from '../features/snackbar/snackbarSlice';

export function MemberQuestions({
  guid
}: {
  guid?: string
}) {
  const { data: user } = useGetUserInfoQuery();
  if (user?.role !== 'member' || !guid)
    return null;

  return (
    <MemberQuestionsInternal
      guid={guid}
    />
  );
}

function MemberQuestionsInternal({
  guid
}: {
  guid: string
}) {
  const [content, setContent] = useState<string>('');
  const [emailOrganizer, { isLoading }] = useEmailOrganizerMutation();
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch();

  return (
    <>
      <Button
        onClick={() => {
          setContent('')
          setOpen(true)
        }}
        style={{
          marginTop: 10
        }}
        startIcon={<EmailIcon />}
        variant='outlined'
      >Send email</Button>
      <Dialog
        fullWidth
        maxWidth='md'
        open={open}
        PaperProps={{
          style: {
            backgroundColor: '#a0b1af'
          }
        }}
      >
        <DialogTitle>
          <Typography
            fontSize={22}
          >Email Organizer</Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Paper
            elevation={0}
            style={{
              alignItems: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              padding: 26
            }}
          >
            <TextField
              fullWidth
              multiline
              onChange={e => setContent(e.target.value)}
              required
            />
            <Button
              disabled={isLoading}
              onClick={() => {
                emailOrganizer({
                  content,
                  guid,
                })
                  .then(() => setOpen(false))
                  .then(() =>
                    dispatch(
                      toast({
                        message: 'Email Successfully Sent',
                        severity: 'success',
                      })
                    )
                  )
              }}
            >{isLoading
              ? <CircularProgress
                size={25} />
              : 'Send'}</Button>
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
}
